import { render, staticRenderFns } from "./email-communication-tile.vue?vue&type=template&id=74a30a05&scoped=true&"
import script from "./email-communication-tile.vue?vue&type=script&lang=js&"
export * from "./email-communication-tile.vue?vue&type=script&lang=js&"
import style0 from "./email-communication-tile.vue?vue&type=style&index=0&id=74a30a05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a30a05",
  null
  
)

export default component.exports